<template>
    <div class="tool-bar">
        <div class="left">
            <slot name="left"></slot>
        </div>
        <div class="right">
            <slot name="right"></slot>
        </div>
    </div>
</template>
<script>
export default {
    
}
</script>
<style lang="scss" scoped>
    .tool-bar {
        display: flex;
        align-items: center;
        justify-content: space-between;

        .left, .right {
            display: flex;
            align-items: center;
        }
    }
</style>